<template>
    <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
        <div class="mt-6 flex items-center justify-between px-6">
            <h4>Modifier un dossier</h4>
            <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"/>
        </div>
        <vs-divider class="mb-0" />
        <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">
          <div class="px-3 mt-2">
            <vs-input v-model="form.dossier" :danger="errors_data.dossier ? true : false" :danger-text="errors_data.dossier ? errors_data.dossier[0] : ''" label="Nom du dossier" class="w-full"></vs-input>
          </div>
          <div class="px-3 mt-2">
            <vs-input v-model="form.date" :danger="errors_data.date ? true : false" :danger-text="errors_data.date ? errors_data.date[0] : ''" type="date" label="Date" class="w-full"></vs-input>
          </div>
        </VuePerfectScrollbar>
        <div class="flex flex-wrap items-center p-6" slot="footer">
            <vs-button @click="addFolder" class="mr-6" >Soumettre</vs-button>
            <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Annuler</vs-button>
        </div>
    </vs-sidebar>
</template>

<script>
  const DEFAULT_FORM = {
    id: '',
    dossier: '',
    date: ''
  }
    import VuePerfectScrollbar from 'vue-perfect-scrollbar';
    export default {
        components: {VuePerfectScrollbar},
        props: {
            isSidebarActive: {
                type: Boolean,
                required: true
            },
            callBackFunction:{
              type: Function
            },
            model:{
              type: Object,
              default: {}
            }
        },
        data() {
            return {
                settings: {
                    maxScrollbarLength: 60,
                    wheelSpeed: .60,
                },
              errors_data: [],
              form:{
                  id: '',
                  dossier: '',
                  date: ''
              }
            }
        },
        computed: {
            isSidebarActiveLocal: {
                get() {
                    return this.isSidebarActive
                },
                set(val) {
                    if(!val) {
                        this.$emit('closeUpdate')
                    }
                    this.errors_data = []
                }
            },
        },
        methods: {
          addFolder(){
            this.$vs.loading()
            this.$http.post('/folders/update', this.form).then((response) =>{
              this.$vs.loading.close()
              if (response.data.status){
                window.GETCCMT.success('Mise à jour éffectuée', response);
                this.form = { ...DEFAULT_FORM }
                this.$emit('closeUpdate')
                this.callBackFunction(1)
              }else {
                window.GETCCMT.error({ message: 'Opération échouée.' });
              }
            }).catch((error) =>{
              this.$vs.loading.close()
              this.errors_data = error.response.data.errors
            })
          }
        },
        watch: {
          isSidebarActive(val) {
            this.form.id = this.model ? this.model.id : ''
            this.form.dossier = this.model ? this.model.name : ''
            this.form.date = this.model ? this.model.planned_date : ''
            if(!val) return;
          }
        },

    }
</script>

<style lang="scss" scoped>
    .add-new-data-sidebar {
        ::v-deep .vs-sidebar--background {
            z-index: 52010;
        }

        ::v-deep .vs-sidebar {
            z-index: 52010;
            width: 350px;
            max-width: 90vw;

            .img-upload {
                margin-top: 2rem;

                .con-img-upload {
                    padding: 0;
                }

                .con-input-upload {
                    width: 100%;
                    margin: 0;
                }
            }
        }
    }

    .scroll-area--data-list-add-new {
        // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
        height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
    }
</style>
